// Shared CSV export helper for report views.
// Produces a UTF-8 CSV (with BOM so Excel opens it correctly) and triggers a download.

function escapeCell(value) {
  if (value === null || value === undefined) return '';
  const s = String(value);
  // Quote cells containing commas, quotes, or newlines
  if (/[",\n\r]/.test(s)) {
    return '"' + s.replace(/"/g, '""') + '"';
  }
  return s;
}

/**
 * Export rows to CSV.
 * @param {string} filename - download filename (without extension)
 * @param {Array}  columns  - [{ text: 'Header Label', value: 'fieldName' }, ...]
 * @param {Array}  rows     - array of row objects
 */
export function exportCsv(filename, columns, rows) {
  const headerLine = columns.map((c) => escapeCell(c.text)).join(',');
  const lines = (rows || []).map((row, i) =>
    columns
      .map((c) => escapeCell(c.value === 'index' ? i + 1 : row[c.value]))
      .join(',')
  );
  const csv = '﻿' + [headerLine, ...lines].join('\r\n');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = `${filename}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(link.href);
}
